module.exports = {
  header_menu: {
      login:'登录',
      register:'注册',
      logout:'退出登录',
  },
  home:require("./home/homeCN")
}
